import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ number, label }) => (
  <p
    data-testid={`chapter-tag-${number}`}
    className="font-mono text-xs uppercase tracking-[0.25em] text-[#E05A10]"
  >
    {number} <span className="text-[#8C857B]">//</span> {label}
  </p>
);
